<template>
  <div class="sh-blocked-users">
    <div v-if="blockedUserIds.length === 0" class="sh-blocked-users-empty">
      You haven’t blocked anyone.
    </div>
    <div v-for="uid in blockedUserIds" :key="uid" class="sh-blocked-users-row">
      <UserAvatar
        :pUserId="uid"
        pSize="28px"
        p-line-height="28px"
        p-font-size="0.85rem"
        type="author-avatar"
      />
      <span class="sh-blocked-users-name">{{ displayName(uid) }}</span>
      <button type="button" class="sh-blocked-users-unblock" @click="unblock(uid)">Unblock</button>
    </div>
    <BlockUserConfirm :visible="pendingUnblockId != null" mode="unblock" @confirm="confirmUnblock" @cancel="pendingUnblockId = null" />
    <BlockToast />
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from "vuex";
import UserAvatar from "./UserAvatar.vue";
import BlockToast from "./BlockToast.vue";
import BlockUserConfirm from "./BlockUserConfirm.vue";
// Styles for the rows/toast live in the shared messaging sheet; importing
// here makes the list self-sufficient on the settings page.
import "@/stylesheets/sh-messaging.css";

// The "Blocked Users" list: one row per blocked user with an Unblock
// button. Lives in the User Settings accordion (/settings?open=blocked).
export default {
  name: "BlockedUsersList",
  components: { UserAvatar, BlockToast, BlockUserConfirm },
  data() {
    return {
      // User id awaiting confirmation in the Unblock dialog; null when closed.
      pendingUnblockId: null
    };
  },
  computed: {
    ...mapState("user", ["usersById"]),
    ...mapGetters("blockedUsers", ["blockedUserIds"])
  },
  async created() {
    await this.fetchBlockedUsers();
    this.fetchBlockedUserProfiles();
  },
  methods: {
    ...mapActions("blockedUsers", ["fetchBlockedUsers", "fetchBlockedUserProfiles", "unblockUser"]),
    displayName(uid) {
      const u = this.usersById[uid];
      if (u && u.attributes) {
        return `${u.attributes["first-name"] || ""} ${u.attributes["last-name"] || ""}`.trim() || `User ${uid}`;
      }
      return `User ${uid}`;
    },
    unblock(uid) {
      this.pendingUnblockId = uid;
    },
    confirmUnblock() {
      const uid = this.pendingUnblockId;
      this.pendingUnblockId = null;
      if (uid != null) { this.unblockUser({ userId: uid }); }
    }
  }
};
</script>
